import styled, { css } from 'styled-components';

export const ScorersWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 0px;
`;

export const Scorers = styled.ul`
  -webkit-padding-start: 0;
  list-style: none;
  margin: 0px;
  color: ${props => props.color};
  font-weight: ${props => props.weight};
  margin-left: ${props => props.marginLeft}em;
  border-top: none !important;
  font-size: 16px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    font-size: 12px;
  };
  text-align: ${props => props.align};
  ${props => (props.font) && css` 
  font-family: ${props.theme.fontSets[props.font]};
  `};
`;

export const PlayerName = styled.span`
  margin-right: 3px;
`;

export const Scorer = styled.li`
  margin: 0.2em 0;
  font-family: ${props => props.theme.fontSets[props.font]};
  line-height: 1.1;
`;

export const GoalType = styled.span`
  font-family: ${props => props.theme.fontSets[props.font]};
  margin-left: 0.2em;
  margin-right: 3px;
`;



// WEBPACK FOOTER //
// ./src/components/shared/MatchRowScorers/styles.js